// extracted by mini-css-extract-plugin
export default {"queryContainer":"CrashesPage_queryContainer__6+dhe","contentContainer":"CrashesPage_contentContainer__-UjNX","disclaimer":"CrashesPage_disclaimer__hkvP3"};